import React, { useEffect, useLayoutEffect } from "react";
import styles from "./Notifications.module.css";
import { TextComponent } from "../../components";
import { List } from "antd";
import { useDispatch, useSelector } from "react-redux";
import { PagesMiddleware } from "../../Store/Middlewares/PagesMiddleware";
import { resetNotificationCount } from "../../Store/Actions/GeneralActions";
import { useLocation } from "react-router-dom";
import { LeftOutlined, RightOutlined } from "@ant-design/icons";
const Notifications = () => {
  const dispatch = useDispatch();
  const Notification = useSelector(
    (state) => state.GeneralReducer.getNotifications,
  );
  const notificationsListPagination = useSelector(
    (state) => state.GeneralReducer.getNotificationsPagination,
  );

  useEffect(() => {
    dispatch(PagesMiddleware.get_Notification({ url: undefined })).then(
      () => {},
    );
  }, []);

  const location = useLocation();

  useLayoutEffect(() => {
    dispatch(resetNotificationCount());
  }, []);

  const dummyNotifications = [
    {
      id: 1,
      message:
        "Security system triggered due to an unauthorized vehicle access attempt.",
      isRead: false,
      time: "6m",
    },
    {
      id: 2,
      message:
        "An unauthorized attempt to access your vehicle was detected. Immobilizer activated.",
      isRead: true,
      time: "10m",
    },
    {
      id: 3,
      message:
        "Please check your vehicle's security settings for any alerts or issues.",
      isRead: false,
      time: "26m",
    },
    {
      id: 4,
      message:
        "Security system triggered due to an unauthorized vehicle access attempt.",
      isRead: false,
      time: "6m",
    },
    {
      id: 5,
      message:
        "An unauthorized attempt to access your vehicle was detected. Immobilizer activated.",
      isRead: true,
      time: "10m",
    },
    {
      id: 6,
      message:
        "Please check your vehicle's security settings for any alerts or issues.",
      isRead: false,
      time: "26m",
    },
  ];
  return (
    <div className={styles.mainCont}>
      <TextComponent
        text={"Alerts"}
        style={{
          fontFamily: "Urbanist-bold",
          fontSize: "var(--heading1-font-size)",
        }}
      />
      <List
        dataSource={Notification}
        style={{ margin: "20px 0" }}
        renderItem={(item, index) => {
          return (
            <div className={styles.listItem}>
              <TextComponent
                className={
                  item?.is_read == 1 ? styles.notiDot : styles.nonActivenotiDot
                }
                text={"●"}
              />
              <div className={styles.messageBox}>
                <TextComponent
                  style={{ fontFamily: "Urbanist-regular" }}
                  className={styles.notiMess}
                  text={item?.description ? item?.description : "--"}
                />
                <TextComponent
                  style={{ fontFamily: "Urbanist-regular" }}
                  className={styles.notiTime}
                  text={item?.time_ago ? item?.time_ago : "--"}
                />
              </div>
            </div>
          );
        }}
        pagination={{
          showSizeChanger: false,
          showQuickJumper: false,
          current: notificationsListPagination?.meta?.current_page,
          pageSize: notificationsListPagination?.meta?.per_page,
          total: notificationsListPagination?.meta?.total,
          onChange: (page, pageSize) => {
            dispatch(
              PagesMiddleware.get_Notification({
                url: `${notificationsListPagination?.meta?.path}?page=${page}`,
              }),
            );
          },
          itemRender: (_, type, originalElement) => {
            if (type === "prev") {
              return (
                <span
                  style={{
                    color: notificationsListPagination?.links?.prev
                      ? "inherit"
                      : "#ccc",
                    cursor: notificationsListPagination?.links?.prev
                      ? "pointer"
                      : "not-allowed",
                  }}
                  onClick={() => {
                    dispatch(
                      PagesMiddleware.get_Notification({
                        url: notificationsListPagination?.links?.prev,
                      }),
                    );
                  }}
                >
                  <LeftOutlined /> Prev
                </span>
              );
            }
            if (type === "next") {
              return (
                <span
                  style={{
                    color: notificationsListPagination?.links?.next
                      ? "inherit"
                      : "#ccc",
                    cursor: notificationsListPagination?.links?.next
                      ? "pointer"
                      : "not-allowed",
                  }}
                  onClick={() => {
                    dispatch(
                      PagesMiddleware.get_Notification({
                        url: notificationsListPagination?.links?.next,
                      }),
                    );
                  }}
                >
                  Next <RightOutlined />
                </span>
              );
            }
            return originalElement;
          },
        }}
      />
    </div>
  );
};

export default Notifications;
